<!-- ═══════════════════════════════════════════════════════════════════════
     HOME PAGE — chargement progressif
     • Hero : chargé immédiatement (above-the-fold)
     • Autres sections : différées via @defer
       → ne se chargent QUE quand elles entrent dans le viewport (scroll)
       → libère le loader global dès que le hero est prêt
     ═══════════════════════════════════════════════════════════════════════ -->

<!-- Hero : critique, charge tout de suite -->
<app-hero></app-hero>

<!-- About : se charge dès que le hero est terminé (idle) -->
@defer (on idle; prefetch on idle) {
  <app-about></app-about>
} @placeholder (minimum 300ms) {
  <div class="home-skeleton" aria-hidden="true">
    <div class="home-skeleton__bar"></div>
  </div>
}

<!-- Counter : se charge quand il est visible -->
@defer (on viewport; prefetch on idle) {
  <app-counter></app-counter>
} @placeholder (minimum 300ms) {
  <div class="home-skeleton home-skeleton--sm" aria-hidden="true">
    <div class="home-skeleton__bar"></div>
  </div>
}

<!-- Features : viewport -->
@defer (on viewport; prefetch on idle) {
  <app-features></app-features>
} @placeholder (minimum 300ms) {
  <div class="home-skeleton" aria-hidden="true">
    <div class="home-skeleton__bar"></div>
  </div>
}

<!-- News : viewport -->
@defer (on viewport; prefetch on idle) {
  <app-news></app-news>
} @placeholder (minimum 300ms) {
  <div class="home-skeleton" aria-hidden="true">
    <div class="home-skeleton__bar"></div>
  </div>
}

<!-- Carte Google My Maps — viewport -->
 
  <app-map></app-map>
 